const mainUrl = (
  process.env.REACT_APP_AUTOAPPY_MAIN_URL?.trim() || "https://autoappy.com"
).replace(/\/+$/, "");

export function autoAppyUrl(path) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${mainUrl}${normalizedPath}`;
}
